import { Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Helper } from 'src/app/accountancy/utilities/classes/helper.class';
import { ReportFilterInterface } from '../report-filter/report-filter.component';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-general-ledger-visual',
  templateUrl: './general-ledger-visual.component.html',
  styleUrls: ['./general-ledger-visual.component.scss']
})
export class GeneralLedgerVisualComponent {

  public readonly waitHandler = Helper.newWaitHandler();
  public readonly rendered$ = new BehaviorSubject<boolean>(true);
  public readonly fg = this._newFg();

  constructor() { }

  public onSubmit(body: ReportFilterInterface) {
    // request here
  }

  private _newFg() {
    const [year, month] = Helper.date.dateDestruct(new Date());

    return new FormGroup({
      GenerateBy: Helper.reactiveForms.control<string>('yearly'),
      YearStart: Helper.reactiveForms.control<number>(year - 3),
      YearEnd: Helper.reactiveForms.control<number>(year),
      Year: Helper.reactiveForms.control<number>(year),
      Month: Helper.reactiveForms.control<number>(month),
    });
  }

}
